import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}irsh/translate`;

export interface GetClaimTranslationQueryArgs {
  issueId?: string;
  reasonId?: string;
  warrantyTypeId?: string;
  solutionId?: string;
}

export const getClaimTranslationRequest = ({
  issueId,
  reasonId,
  solutionId,
  warrantyTypeId,
}: GetClaimTranslationQueryArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { issueId, reasonId, solutionId, warrantyTypeId },
  },
});

export const getClaimTranslationQuery = async (
  args: GetClaimTranslationQueryArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getClaimTranslationRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
